import { Link } from 'react-router-dom';

// P2b-3 Build View commit 7 — entry-point icon rendered inline with
// the Location cell on the Meta + Google role grids. Click navigates
// to the Build View, passing the post-filter, post-sort row IDs in
// location.state so Prev/Next walk the same set the buyer sees.
//
// Item 4 polish: this is the buyer's primary per-row action, so it
// reads as a button — boxed, brand-blue, with a hover state and a
// larger eye — not a faint grey glyph that's easy to skim past.
// Platform-specific tooltip ("Open Meta Build View" on Meta).

type Props = {
  rolloutId: string;
  rowId: string;
  platform: 'meta' | 'google';
  locationLabel: string;
  filteredRowIds: string[];
};

export function BuildViewLink({
  rolloutId,
  rowId,
  platform,
  locationLabel,
  filteredRowIds,
}: Props) {
  const tooltip =
    platform === 'meta' ? 'Open Meta Build View' : 'Open Build View';
  return (
    <Link
      to={`/rollouts/${rolloutId}/grid/${platform}/${rowId}/build`}
      state={{ filteredRowIds }}
      aria-label={`${tooltip} for ${locationLabel}`}
      title={tooltip}
      className="inline-flex items-center justify-center w-7 h-7 rounded-md border border-blue-200 bg-blue-50 text-blue-600 transition-colors hover:bg-blue-100 hover:text-blue-700 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
    >
      <EyeIcon />
    </Link>
  );
}

function EyeIcon() {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
